import {type Node} from 'datocms-structured-text-utils'
import {type ArticleWysiwygFragment} from '~/cms/components/_blog/ArticleWYSIWYG/_generated/fragment.graphql'
import {type LegalWysiwygFragment} from '~/cms/components/_FEM/LegalWYSIWYG/_generated/fragment.graphql'
import {formatHeadingLink} from '~/cms/components/WYSIWYG/_utils/nodeRules'

export const getTableOfContentSections = (
  content:
    | NonNullable<ArticleWysiwygFragment['article']>
    | NonNullable<LegalWysiwygFragment['body']>
) => {
  const children = content.value?.document?.children as Node[]
  if (!children) return []
  const sections = children
    .filter(
      child =>
        child.type === 'heading' && child.level === 2 && child.children.length > 0
    )
    .map(formatHeadingLink)
  return sections
}
